import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderForm: 38,
    orderStatus: 1,
    serviceOption: "",
    orderOption: "",
    plateAmount: 0,
    tableData: [],
    selectedPlate: 1,
    dropBoxId: null,
    dropBoxDate: "",
    orderAmount: 0,
    discountId: null
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "Dropbox",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
    ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  primer: {
    primerList: [],
    primerAmount: "",
    banking: 0,
    comments: "",
    primerSynthesisList: [],
    synthesis: 0,
  },
};

const fragFormSlice = createSlice({
  name: "fragorderform",
  initialState,
  reducers: {
    //action creators
    initializeFragTableData(state, action) {
      const data = [];
      let idValue = 1;
      let plateValue = 1;
      let rowValue = 1;

      // Loop to create objects for each set of 96 iterations
      for (let j = 0; j < action.payload; j++) {
        const setOfData = []; // Array to hold objects for each set of 96 iterations

        // Loop for each set of 96 iterations
        for (let i = 1; i <= 96; i++) {
          const startCharCode = "A".charCodeAt(0);
          const colLabel = String.fromCharCode(startCharCode + ((i - 1) % 8)); // Calculate the column label (A-H)
          const rowLabel = Math.ceil(rowValue / 8); // Calculate the row label (1-12)

          const newObj = {
            id: idValue,
            well: colLabel + rowLabel,
            dName: "",
            dConc: "",
            dType: "",
            pcrSize: "",
            library: "",
            pName: "",
            pConc: "",
            alt: "",
            pbp: false,
            orderId: 0,
            plateIndex: plateValue,
          };

          setOfData.push(newObj);

          rowValue++;
          idValue++;
        }

        // Add additional key-value pairs to the last object in the set
        // const lastObj = setOfData[setOfData.length - 1];
        // lastObj.templateConcentration = "";
        // lastObj.dnaType = "";
        // lastObj.sizeOfPcr = "";
        // lastObj.primerConcentration = "";
        // lastObj.alt = "";

        // Create the main object for the set of data
        const setDataObj = {
          samples: setOfData, // Array of samples
          additionalInfo: {
            // Additional key-value pairs
            templateConcentration: "",
            dnaType: "",
            sizeOfPcr: "",
            primerConcentration: "",
            alt:"",
            plateName: "",
            staging: 2,
            analysis: 2,
          },
        };

        // Push the set of data object into the main data array
        data.push(setDataObj);

        // Reset values for the next set
        idValue = 1;
        plateValue++;
        rowValue = 1;
      }

      state.data.tableData = data;
      return;
    },
    addFragPlate(state, action) {
      const data = []
      const previous =  JSON.parse(JSON.stringify(state.data.tableData))
      // console.log('prev',previous);

      previous.map(x => {
        data.push(x)
      })

      let idValue = 1;
      let plateValue = state.data.plateAmount;
      let rowValue = 1;

      // Loop to create objects for 1 more of 96 iterations
      for (let j = 0; j < 1; j++) {
        const setOfData = []; // Array to hold objects for each set of 96 iterations

        // Loop for each set of 96 iterations
        for (let i = 1; i <= 96; i++) {
          const startCharCode = "A".charCodeAt(0);
          const colLabel = String.fromCharCode(startCharCode + ((i - 1) % 8)); // Calculate the column label (A-H)
          const rowLabel = Math.ceil(rowValue / 8); // Calculate the row label (1-12)

          const newObj = {
            id: idValue,
            well: colLabel + rowLabel,
            dName: "",
            dConc: "",
            dType: "",
            pcrSize: "",
            library: "",
            pName: "",
            pConc: "",
            alt: "",
            pbp: false,
            orderId: 0,
            plateIndex: plateValue,
          };

          setOfData.push(newObj);

          rowValue++;
          idValue++;
        }

        // Create the main object for the set of data
        const setDataObj = {
          samples: setOfData, // Array of samples
          additionalInfo: {
            // Additional key-value pairs
            templateConcentration: "",
            dnaType: "",
            sizeOfPcr: "",
            primerConcentration: "",
            alt:"",
            plateName:"",
            staging: 2,
            analysis: 2,
          },
        };

        // Push the set of data object into the main data array
        data.push(setDataObj);
      }
      // console.log('slicedata', data);
      state.data.tableData = data;
      return;
    },
    resetFragState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetFragTableData(state, action) {
      state.data.tableData = action.payload;
      return;
    },
    setFragPlateAmount(state, action) {
      state.data.plateAmount = action.payload;
      return;
    },
    clearFragServiceOption(state, action) {
      state.data.serviceOption = action.payload;
      return;
    },
    setFragServiceOption(state, action) {
      state.data.serviceOption = action.payload;
      return;
    },
    clearFragOrderOption(state, action) {
      state.data.orderOption = action.payload;
      return;
    },
    setFragOrderOption(state, action) {
      state.data.orderOption = action.payload;
      return;
    },
    handleFragLeftArrow: (state) => {
      if (state.data.selectedPlate > 1) {
        state.data.selectedPlate -= 1;
      }
    },
    handleFragRightArrow: (state) => {
      if (state.data.selectedPlate < state.data.plateAmount) {
        state.data.selectedPlate += 1;
      }
    },
    editFragRow(state, action) {
      const { index, plateIndex, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;

      // Find the target sample object
      const sample = state.data.tableData[plateIndex - 1].samples[index];

      // Update the target property if it exists and passes the pattern test
      if (property === "dName" || property === "pName") {
        if (pattern.test(value)) {
          sample[property] = value;
        } else {
          // Handle invalid input
          return;
        }
      } else {
        sample[property] = value;
      }
    },
    // editFragRow(state, action) {
    //   const { index, plateIndex, property, value } = action.payload;
    //   let pattern = /^[a-zA-Z0-9_-]*$/;
    //   const updatedData = [...state.data.tableData];

    //   // Filter the tableData array to get objects with matching plateIndex
    //   const filteredData = updatedData.map((item) => console.log(item));
    //   console.log(filteredData);

    //   if (property === "dName" || property === "pName") {
    //     if (pattern.test(value)) {
    //       filteredData[index][property] = value;
    //     } else {
    //       // You may want to handle this case differently, e.g., show an error message
    //       return;
    //     }
    //   } else {
    //     filteredData[index][property] = value;
    //   }

    //   // Update the original data array with the filtered data
    //   updatedData.forEach((item, i) => {
    //     if (item.plateIndex === plateIndex) {
    //       updatedData[i] = filteredData.shift();
    //     }
    //   });

    //   state.data.tableData = updatedData;
    // },
    setFragTemplateConc: (state, action) => {
      const {plate, conc} = action.payload;
      // console.log(plate,conc);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.templateConcentration = conc
      state.data.tableData = updatedData
    },
    setFragPlateName: (state, action) => {
      const {plate, name} = action.payload;
      // console.log(plate,conc);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.plateName = name
      state.data.tableData = updatedData
    },
    setFragPrimerConc: (state, action) => {
      const {plate, conc} = action.payload;
      // console.log(plate,conc);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.primerConcentration = conc
      state.data.tableData = updatedData
    },
    setFragStaging: (state, action) => {
      const {plate, conc} = action.payload;
      // console.log('frag staging', plate,conc);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.staging = Number(conc)
      state.data.tableData = updatedData
    },
    setFragAnalysis: (state, action) => {
      const {plate, conc} = action.payload;
      // console.log(plate,conc);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.analysis = Number(conc)
      state.data.tableData = updatedData
    },
    setFragDnaType: (state, action) => {
      const {plate, type} = action.payload;
      // console.log(plate,type);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.dnaType = type.label
      state.data.tableData = updatedData
      // return;
    },
    setFragPcrSize: (state, action) => {
      const {plate, size} = action.payload;
      // console.log(plate,size);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.sizeOfPcr = size.label
      state.data.tableData = updatedData
    },
    setFragAlt: (state, action) => {
      const {plate, alt} = action.payload;
      // console.log(plate,alt);
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))
      
      updatedData[plate-1].additionalInfo.alt = alt.label
      state.data.tableData = updatedData
    },
    toggleFragCheckbox: (state, action) => {
      const { index, plateIndex, property } = action.payload;
      let updatedData = JSON.parse(JSON.stringify(state.data.tableData))

      // console.log(index,plateIndex,property);
      // console.log(updatedData);
     
      let updateLocation = updatedData[plateIndex-1].samples[index][property]
      updatedData[plateIndex-1].samples[index][property] = !updateLocation
      state.data.tableData = updatedData;

    },
    increaseFragConcentration(state, action) {
      const {plate, property} = action.payload;
      // console.log(state.data.tableData[plate-1].additionalInfo[property]);
      if(state.data.tableData[plate-1].additionalInfo[property] === ""){
        state.data.tableData[plate-1].additionalInfo[property] =  1;
      }
      else{
        state.data.tableData[plate-1].additionalInfo[property] = parseInt(state.data.tableData[plate-1].additionalInfo[property]) + 1;
      }
    },
    decreaseFragConcentration(state, action) {
      const {plate, property} = action.payload;

      if (state.data.tableData[plate-1].additionalInfo[property] > 0) {
        state.data.tableData[plate-1].additionalInfo[property] = parseInt(state.data.tableData[plate-1].additionalInfo[property]) - 1;
      }
    },
    // clearFragSelect(state, action) {
    //   console.log(action.payload);
      
    //   state.data[action.payload] = "";
    //   return;
    // },
    
    clearFragSelect(state, action) {
      // console.log('here');
      const { index, plateIndex, property, value } = action.payload;
      
      if(property === 'library'){
        // console.log(index, plateIndex, property);
        state.data.tableData[plateIndex - 1].samples[index].library = ''
      }
      else{
        // console.log(plateIndex, property);
        state.data.tableData[plateIndex].additionalInfo[property] = "";
      }
      
      // return;
    },
    fragPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    fragNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    fragSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetFragPage: (state, action) => {
      state.page = action.payload;
    },
    initializeFragPrimerTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          pName: "",
          pSequence: "",
        };
        state.primer.primerSynthesisList.push(newObj);
      }
      return;
    },
    resetFragPrimerTableData(state, action) {
      state.primer.primerSynthesisList = action.payload;
    },
    setFragPrimerAmount(state, action) {
      state.primer.primerAmount = parseInt(action.payload);
      return;
    },
    addFragPrimerRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.primer.primerSynthesisList.push(newRow);

      // Reset the indices in the updated tableData
      state.primer.primerSynthesisList = state.primer.primerSynthesisList.map(
        (item, index) => ({
          ...item,
          id: index + 1,
        })
      );
      state.primer.primerAmount = parseInt(state.primer.primerAmount + 1);
      return;
    },
    editFragPrimerRow(state, action) {
      const { index, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;
      const updatedData = [...state.primer.primerSynthesisList];

      if (property === "pSequence" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.primer.primerSynthesisList = updatedData;
    },
    deleteAllFragPrimer(state, action) {
      state.primer.primerSynthesisList = action.payload;
      state.primer.primerAmount = "";
      return;
    },
    setFragPrimerBanking(state, action) {
      state.primer.banking = action.payload;
      return;
    },
    setFragPrimerList(state, action) {
      const list = action.payload.split(/,\s|\n|,/);
      state.primer.primerList = list;
      // console.log(state.primer.primerList);
      return;
    },
    setFragPrimerSynthesis(state, action) {
      state.primer.synthesis = action.payload;
      return;
    },
    setFragPrimerComments(state, action) {
      // state.primer.comments = action.payload;
        let pattern = /^[a-zA-Z0-9_\- ]*$/;
        let value2 = action.payload

        if (pattern.test(value2)) {
          state.primer.comments = value2;
        } else {
          alert(
            "Only special characters allowed: hyphen( - ) and underscore( _ ) and space."
          );
        }
      return;
    },
    setFragDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setFragDropboxId(state, action) {
      state.data.dropBoxId = action.payload;
      return;
    },
    setFragDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      state.data.dropBoxDate = action.payload;

      // Test the regular expression with a date
      // if (dateRegex.test(result)) {
      // }
    },
    setFragFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setFragLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setFragCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setFragPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;

      // Test the regular expression with a date
      // if (phoneRegex.test(result)) {
      //   state.billingInformation.phone = result;
      // }
      state.billingInformation.phone = result;
    },
    setFragEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setFragShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setFragAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setFragCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setFragCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setFragCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setFragCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
    setFragCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setFragCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setFragCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setFragBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setFragPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setFragPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setFragPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setFragGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setFragGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setFragGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
    setFragSelectedPlate(state, action){
      state.data.selectedPlate = action.payload;
    },
    setFragOrderNumber(state, action) {
      state.data.orderNumber = action.payload
    },
    setFragOrderAmount(state, action) {
      state.data.orderAmount = action.payload
    },
    setFragOrderDiscount(state, action) {
      state.data.discountId = action.payload
    },
    deleteFragPlate(state, action){
      const { index } = action.payload;
      // console.log(index);
      const updatedTableData = JSON.parse(JSON.stringify(state.data.tableData.filter(
        (item, i) => i !== index
      )));

      // console.log(updatedTableData);

      // // Reset the indices in the updated tableData
      const resetIndexedTableData = updatedTableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // // Update the tableData state
      state.data.tableData = resetIndexedTableData;
      state.data.sampleAmount = parseInt(state.data.sampleAmount - 1);
      state.data.plateAmount = parseInt(state.data.plateAmount - 1);
      if(state.data.selectedPlate > 1){
        state.data.selectedPlate = state.data.selectedPlate - 1
      }else{
        state.data.selectedPlate = 1
      }
      return;
    }
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  initializeFragTableData,
  addFragPlate,
  setFragOrderOption,
  clearFragOrderOption,
  setFragServiceOption,
  clearFragServiceOption,
  setFragSelectedPlate,
  setFragOrderNumber,
  setFragOrderAmount,
  setFragOrderDiscount,
  deleteFragPlate,
  setFragPlateAmount,
  setFragAlt,
  setFragDnaType,
  setFragPcrSize,
  setFragPrimerConc,
  setFragTemplateConc,
  setFragPlateName,
  resetFragState,
  resetFragTableData,
  editFragRow,
  toggleCheckbox,
  handleFragLeftArrow,
  handleFragRightArrow,
  toggleFragCheckbox,
  increaseFragConcentration,
  decreaseFragConcentration,
  clearFragSelect,
  fragNextStep,
  fragPrevStep,
  fragSetStep,
  resetFragPage,
  initializeFragPrimerTableData,
  resetFragPrimerTableData,
  setFragPrimerAmount,
  addFragPrimerRow,
  editFragPrimerRow,
  deleteAllFragPrimer,
  setFragPrimerBanking,
  setFragPrimerList,
  setFragPrimerSynthesis,
  setFragPrimerComments,
  setFragDropoffDate,
  setFragDropboxLocation,
  setFragDropboxId,
  setFragFirstName,
  setFragLastName,
  setFragCompany,
  setFragPhone,
  setFragEmail,
  setFragShippingOption,
  setFragAcgtCard,
  setFragCCNumber,
  setFragCCMonth,
  setFragCCYear,
  setFragCVV,
  setFragCCZip,
  setFragCCName,
  setFragCardType,
  setFragPurchasingAgentName,
  setFragPurchasingAgentEmail,
  setFragPoNumber,
  setFragGrantNumber,
  setFragGrantPI,
  setFragGrantNote,
  setFragBillingMethod,
  setFragStaging,
  setFragAnalysis,
} = fragFormSlice.actions;
export const fragFormReducer = fragFormSlice.reducer;
